import React, { useState, useEffect, useMemo } from "react";
import { get, values } from "lodash";
import { Table, Space, Spin } from "antd";
import {
  Box,
  Input,
  Icon,
  Flex,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { RiDeleteBin6Line, RiSearch2Line } from "react-icons/ri";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import styles from "./EventManagementTable.module.scss";
import { useEventManagementMaster } from "../../store/eventmanagement/reducer";
import EventDeleteConfirmation from "../modals/EventDeleteConfirmation";
import axios from "axios";
import { useDispatch } from "react-redux";
import { REQUEST_MASTER_EVENTS } from "../../store/eventmanagement/eventsActionTypes";
interface props {
  query: any;
}

const EventManagementTable: React.FC<props> = ({ query }) => {
  const { masterEventManagement, busy } = useEventManagementMaster();
  console.log(masterEventManagement, "masterEventManagement");
  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(6);

  const toast = useToast();

  const dispatch = useDispatch();

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const [targetevent, setTargetEvent] = useState<any>();

  const deletes = (value: any) => {
    setTargetEvent(value);
    onDeleteOpen();
  };

  const handleApprove = async (record: any) => {
    await axios({
      url: `${process.env.REACT_APP_BASE_URL}/admin/community-events/${record.key}`,
      method: "patch",
      data: {
        status: "approved",
      },
    })
      .then((res) => {
        toast({
          title: "Success.",
          description: `${res.data.message}`,
          status: "success",
          isClosable: true,
          position: "top-right",
        });
        dispatch({ type: REQUEST_MASTER_EVENTS });
      })
      .catch((error) => {
        toast({
          title: "Error.",
          description: `${error.message}`,
          status: "error",
          isClosable: true,
          position: "top-right",
        });
        setLoading(false);
      });
  };

  const handleReject = async (record: any) => {
    await axios({
      url: `${process.env.REACT_APP_BASE_URL}/admin/community-events/${record.key}`,
      method: "patch",
      data: {
        status: "reject",
      },
    })
      .then((res) => {
        toast({
          title: "Success.",
          description: `${res.data.message}`,
          status: "success",
          isClosable: true,
          position: "top-right",
        });
        dispatch({ type: REQUEST_MASTER_EVENTS });
      })
      .catch((error) => {
        toast({
          title: "Error.",
          description: `${error.message}`,
          status: "error",
          isClosable: true,
          position: "top-right",
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);

    const formatEventData = (event: any) => ({
      key: event._id,
      eventImage: event.image?.url
        ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${event.image.url}`
        : "/api/placeholder/40/40",
      communityName: event.community?.name || "-",
      eventName: event.title,
      eventTime: new Date(event.date).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
      location: event.location,
      createdDate: new Date(event.date).toLocaleDateString(),
      status: event.status,
      description: event.description,
      originalData: event,
    });

    const filteredData = masterEventManagement
      .filter((event: any) => {
        if (activeTab === "pending") {
          return event.status === "pending";
        }
        return true;
      })
      .filter((event: any) => {
        if (!searchQuery) return true;
        const communityName = event.community?.name?.toLowerCase() || "";
        return communityName.includes(searchQuery.toLowerCase());
      })
      .map(formatEventData);

    setData(filteredData);
    setLoading(false);
  }, [masterEventManagement, activeTab, searchQuery]);

  const allEventsColumns = [
    {
      title: "Nos.",
      dataIndex: "index",
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Event Image",
      dataIndex: "eventImage",
      render: (image: string) => (
        <img
          src={image}
          alt="Event"
          style={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      ),
    },
    {
      title: "Community Name",
      dataIndex: "communityName",
      // sorter: (a: any, b: any) =>
      //   a.communityName.localeCompare(b.communityName),
    },
    {
      title: "Event Name",
      dataIndex: "eventName",
      // width: 130,
    },
    {
      title: "Event Time",
      dataIndex: "eventTime",
      // width: 130,
    },
    {
      title: "Location",
      dataIndex: "location",
      // width: 130,
    },
    {
      title: "Event Created Date",
      dataIndex: "createdDate",
      // width: 130,
    },
    {
      title: "Action",
      key: "action",
      render: (value: any) => (
        <Space size="middle">
          <RiDeleteBin6Line
            onClick={() => {
              deletes(value);
            }}
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
          />
        </Space>
      ),
    },
  ];

  const pendingRequestsColumns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 80,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Event Image",
      dataIndex: "eventImage",
      width: 100,
      render: (image: string) => (
        <img
          src={image}
          alt="Event"
          style={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      ),
    },
    {
      title: "Community Name",
      dataIndex: "communityName",
    },
    {
      title: "Event Name",
      dataIndex: "eventName",
    },
    {
      title: "Event Time",
      dataIndex: "eventTime",
    },
    {
      title: "Location",
      dataIndex: "location",
    },
    {
      title: "Event Created Date",
      dataIndex: "createdDate",
    },
    {
      title: "Action",
      key: "action",
      render: (value: any) => (
        <Space size="middle">
          <button
            onClick={() => {
              handleApprove(value);
            }}
            style={{
              backgroundColor: "#02A432",
              color: "white",
              border: "none",
              padding: "10px 12px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Approve
          </button>
          <button
            onClick={() => {
              handleReject(value);
            }}
            style={{
              backgroundColor: "#D42F2F",
              color: "white",
              border: "none",
              padding: "10px 12px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Reject
          </button>
        </Space>
      ),
    },
  ];
  const mockData = {
    all: [
      {
        key: "1",
        eventImage: "/api/placeholder/40/40",
        communityName: "Community 1",
        eventName: "Food Festival",
        eventTime: "12:30 PM",
        location: "Sutton, England",
        createdDate: "01/01/2025",
      },
      {
        key: "2",
        eventImage: "/api/placeholder/40/40",
        communityName: "Community 2",
        eventName: "Food Festival",
        eventTime: "12:30 PM",
        location: "Sutton, England",
        createdDate: "01/01/2025",
      },
      {
        key: "3",
        eventImage: "/api/placeholder/40/40",
        communityName: "Community 3",
        eventName: "Food Festival",
        eventTime: "12:30 PM",
        location: "Sutton, England",
        createdDate: "01/01/2025",
      },
    ],
    pending: [
      {
        key: "1",
        eventImage: "/api/placeholder/40/40",
        communityName: "Community 1",
        eventName: "Food Festival",
        eventTime: "12:30 PM",
        location: "Sutton, England",
        createdDate: "01/01/2025",
      },
      {
        key: "2",
        eventImage: "/api/placeholder/40/40",
        communityName: "Community 2",
        eventName: "Food Festival",
        eventTime: "12:30 PM",
        location: "Sutton, England",
        createdDate: "01/01/2025",
      },
      {
        key: "3",
        eventImage: "/api/placeholder/40/40",
        communityName: "Community 3",
        eventName: "Food Festival",
        eventTime: "12:30 PM",
        location: "Sutton, England",
        createdDate: "01/01/2025",
      },
    ],
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh ",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div className={styles.headerSection}>
          <Box className={styles.searchBox}>
            <Box className={styles.searchIcon}>
              <Icon as={RiSearch2Line} width={"24px"} height={"24px"} />
            </Box>
            <Input
              placeholder="Search by community name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className={styles.searchInput}
              padding={"0px"}
              lineHeight={"24px"}
            />
          </Box>
          <div className={styles.tabs}>
            <button
              className={`${styles.tab} ${
                activeTab === "all" ? styles.activeTab : ""
              }`}
              onClick={() => setActiveTab("all")}
            >
              All Events
            </button>
            <button
              className={`${styles.tab} ${
                activeTab === "pending" ? styles.activeTab : ""
              }`}
              onClick={() => setActiveTab("pending")}
            >
              Pending requests
            </button>
          </div>
        </div>

        <div className={styles.tableContainer}>
          {loading ? (
            <Spin size="large" />
          ) : (
            <Table
              rowSelection={rowSelection}
              rowKey="key"
              columns={
                activeTab === "all" ? allEventsColumns : pendingRequestsColumns
              }
              dataSource={data}
              scroll={{ x: "max-content" }}
              size="middle"
              pagination={{
                position: ["bottomRight"],
                pageSize: 9,
              }}
              style={{
                backgroundColor: "white",
                borderRadius: 6,
              }}
              loading={busy && data.length === 0 ? true : false}
            />
          )}
        </div>
      </div>

      {isDeleteOpen && targetevent && (
        <EventDeleteConfirmation
          isOpen
          onClose={onDeleteClose}
          event={targetevent}
        />
      )}
    </>
  );
};

export default EventManagementTable;
